
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {contactService} from "../views/Contacts/services";

const state = {
    contacts:{}
}
const getters = {
    getContacts(state){
        return state.contacts;
    }
}
const mutations = {
    setContacts(state, payload){
        state.contacts = payload;
    }
}
const actions = {
    getContactsAction({ commit }) {
        contactService.fetchContacts().then(
            (result) => {
                commit("setContacts", result);
            },
            (error) => {
                console.log(error);
            }
        );
    },
}

export const contact = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
